"use client";

import { useLayoutEffect, useState } from "react";
import { useRouter } from "next/navigation";

import { LandingPage } from "@/components/LandingPage";
import { supabase } from "@/lib/supabaseClient";

/**
 * Root `/`: show marketing only when there is no Supabase session.
 * Logged-in users are sent to `/dashboard` before the landing UI paints.
 */
export function RootHomeGate() {
  const router = useRouter();
  const [ready, setReady] = useState(false);

  useLayoutEffect(() => {
    let cancelled = false;

    async function run() {
      if (!supabase) {
        if (!cancelled) setReady(true);
        return;
      }
      const { data } = await supabase.auth.getSession();
      if (cancelled) return;
      if (data.session?.user) {
        router.replace("/dashboard");
        return;
      }
      setReady(true);
    }

    void run();
    return () => {
      cancelled = true;
    };
  }, [router]);

  if (!ready) {
    return <div className="ed-root-gate-loading" style={{ minHeight: "100vh" }} aria-busy="true" />;
  }

  return <LandingPage />;
}
